import { render, staticRenderFns } from "./SidebarPublicComponent.vue?vue&type=template&id=0447766c&scoped=true&lang=pug"
import script from "./SidebarPublicComponent.vue?vue&type=script&lang=js"
export * from "./SidebarPublicComponent.vue?vue&type=script&lang=js"
import style0 from "./SidebarPublicComponent.vue?vue&type=style&index=0&id=0447766c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0447766c",
  null
  
)

export default component.exports